import ApiErrorCode from '@/models/enums/ApiErrorCode';
import { isApiResponseInvalid } from '../ApiResponse';

type Converter<T, F> = { mappings: [ApiErrorCode, T][], fallback: F };

export default class ApiError extends Error {
  protected errorCodes: Array<string | undefined>;
  data: unknown;

  constructor(public baseError: unknown) {
    // Determina a mensagem e dados antes de chamar super
    let message: string;
    let errorCodes: Array<string | undefined> = [];
    let errorData: unknown;

    if (baseError instanceof ApiError) {
      // Para instâncias de ApiError, usa a mensagem existente
      message = baseError.message || 'Erro da API';
      errorCodes = [...baseError.errorCodes];
      errorData = baseError.data;
    } else if (isApiResponseInvalid(baseError)) {
      errorCodes = baseError.errors.map((e) => e.code);
      errorData = baseError.data;
      const errorMessages = baseError.errors.map((e) => e.message || e.code).filter(Boolean);
      message = errorMessages.length > 0 ? errorMessages.join('; ') : 'Erro da API';
    } else {
      errorCodes = [];
      errorData = undefined;
      message = 'Erro desconhecido da API';
    }

    // Chama super primeiro (obrigatório em classes derivadas)
    super(message);
    this.name = 'ApiError';
    this.message = message;
    this.errorCodes = errorCodes;
    this.data = errorData;

    // Mantém o stack trace correto (captureStackTrace é específico do V8/Node.js)
    type StackTraceConstructor = abstract new (...args: unknown[]) => unknown;
    const ErrorConstructor = Error as unknown as {
      captureStackTrace?: (error: Error, constructor: StackTraceConstructor) => void;
    };
    if (ErrorConstructor.captureStackTrace) {
      ErrorConstructor.captureStackTrace(this, ApiError);
    }
  }

  is(code: ApiErrorCode): boolean {
    return this.errorCodes.includes(code);
  }

  convertTo<T, F = T>({ mappings, fallback }: Converter<T, F>): T | F {
    for (let i = 0; i < mappings.length; i += 1) {
      const [code, value] = mappings[i];
      if (this.is(code)) return value;
    }
    return fallback;
  }
}
